export const EXPORT_COMPANY_CONTENT_LABELS = {
  assessmentStatusHeading: 'ASSESSMENT STATUS',
} as const
